/**
 * @file Re-exports the mobile update modal and its handle type.
 */

import UserMobileUpdateModal from "./UserMobileUpdateModal";

export type { UserMobileUpdateModalHandle } from "./UserMobileUpdateModal";
export default UserMobileUpdateModal;
